// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"ScoringCard_innerContainer__YWWet","rolesInfo":"ScoringCard_rolesInfo__21CLt","label":"ScoringCard_label__3Cob2"};